import { apiSlice } from "@/redux/apiSlice";
import { ApiResponse } from "@/types";
import { PriceMaster, PriceMasterTable } from "@/types/system-setting/priceMaster";

interface PriceMasterInput {
  query?: string;
  org_id: number;
}

export const PriceMasterApi = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      getPriceMasterById: builder.query<PriceMaster, { id: number; org_id: number }>({
        query: ({ id, org_id }) => ({
          url: `/pricing-master/${id}?org_id=${org_id}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["PriceMaster"],
      }),
      getPriceMasters: builder.query<PriceMasterTable, PriceMasterInput>({
        query: (input) => ({
          url: `/pricing-master?${input.query}&org_id=${input.org_id}`,
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }),
        providesTags: ["PriceMaster", "SysConfig"],
      }),
      createPriceMaster: builder.mutation<ApiResponse, PriceMaster>({
        query: (data) => ({
          url: `/pricing-master`,
          method: "POST",
          body: data,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["PriceMaster", "SysConfig"],
      }),
      updatePriceMaster: builder.mutation<ApiResponse, PriceMaster>({
        query: (data) => ({
          url: `/pricing-master/${data.id}`,
          method: "PUT",
          body: data,
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["PriceMaster", "SysConfig"],
      }),
      deletePriceMaster: builder.mutation<ApiResponse, { id: number; org_id: number }>({
        query: ({ id, org_id }) => ({
          url: `/pricing-master/${id}?org_id=${org_id}`,
          method: "DELETE",
          headers: {
            Accept: "application/json",
          },
        }),
        invalidatesTags: ["PriceMaster", "SysConfig"],
      }),
    };
  },
});

export const {
  useGetPriceMasterByIdQuery,
  useGetPriceMastersQuery,
  useLazyGetPriceMasterByIdQuery,
  useLazyGetPriceMastersQuery,
  useCreatePriceMasterMutation,
  useUpdatePriceMasterMutation,
  useDeletePriceMasterMutation,
} = PriceMasterApi;
